module.exports = __webpack_public_path__ + "img/prog-java (1).5b20b3a6.png";